<template>
  <v-select label="name"
            :class="classObject"
            :filterable="false"
            :options="options"
            v-model="selected"
            @blur="() => { $emit('blur')}"
            @input="updateInput()"
            @search="onSearch"
            >
    <template slot="no-options">
      Escribe al menos 3 dígitos para buscar...
    </template>
    <template slot="option" slot-scope="option">
      <div class="d-center">
        {{ option.text }} 
      </div>
    </template>
    <template slot="selected-option" slot-scope="option">
      <div class="selected d-center">
        {{ option.text }}
      </div>
    </template>
    <template v-slot:spinner="spinner">
      <b-spinner v-show="loading" small></b-spinner>
    </template>
  </v-select>
</template>
<script>

import vSelect from 'vue-select'

  export default {
    name: "searchSelect",
    props: {
      url: {
        type: String,
        default: ''
      },
      submitActive: {
        type: Boolean,
        default: false
      },
      validation: {
        type: Object,
        default() {
          return {}
        }
      },
    },
    components: {
      vSelect
    },
    data() {
      return {
        selected: null,
        modalShown: false,
        options: [],
        loading: false,
      }
    },
    computed:{
     classObject: function ()  {
          return {
          'custom-select': true,
          'style-chooser': true,
          'is-valid': (this.errorValidation == false  && this.dirtyValidation==true ) ? true : false,
          'is-invalid': (this.errorValidation == true  &&  (this.dirtyValidation==true || this.submitStatusChange==true )) ? true : false
        }
      },
      submitStatusChange:function (){
        return this.submitActive;
      },
      dirtyValidation:function (){
        return this.validation.$dirty;
      },
      errorValidation:function (){
        return this.validation.$error;
      }
    },
    methods: {
      handleBlur() {
        this.$emit("handle-blur", this.selected);
      },
      updateInput() {
        this.$emit("input", this.selected);
        this.$emit("blur", this.selected);
      },
      onSearch(search, loading) {
        if (search.length>=3){
          this.loading=true;
          this.search(loading, search, this);
        }
      },
      search: _.debounce((loading, search, vm) => {
        let search_url = vm.url.slice(-1) === '/' ? vm.url + `?q=${escape(search)}` : vm.url + `&q=${escape(search)}`;
        vm.$axios.get(search_url)
          .then(res => {
            vm.options = res.data;
            vm.loading=false;
            loading(false);
          })
          .catch(error => {
            loading(false);
            console.log(error.response)
          });
      }, 350),
    }

  }
</script>

<style>
  .style-chooser .vs__search::placeholder,
  .style-chooser .vs__dropdown-toggle,
  .style-chooser .vs__dropdown-menu {
    min-height: calc(1.5em + 0.75rem + 2px);
    font-size: 0.6875rem;
    font-weight: 400;
    color: #5c6873;
    border: none;
    margin-top: -7px;
    margin-left: -10px;
  }
  .style-chooser .vs__clear,
  .style-chooser .vs__open-indicator {
    fill: #394066;
  }

</style>
